/**
 * UC-15: EvaluateThreat
 * Aggregates threat delta, policy modifiers, and breach mitigation rules.
 */
import type { IAppLogger } from '../../domain/ports/IAppLogger';

export type ThreatBreachEvent = 'diode_mitigated' | 'data_breach';

export interface EvaluateThreatInput {
  currentThreat: number;
  dailyThreatDelta: number;
  policyThreatEffectTotal: number;
  hasDiode: boolean;
  threatHistory: number[];
}

export interface EvaluateThreatOutput {
  threat: number;
  threatHistory: number[];
  complianceDelta?: number;
  breachEvent?: ThreatBreachEvent;
  playAlertSfx?: boolean;
}

export interface EvaluateThreatDependencies {
  logger?: IAppLogger;
}

export class EvaluateThreatUseCase {
  constructor(private readonly deps: EvaluateThreatDependencies = {}) {}

  execute(input: EvaluateThreatInput): EvaluateThreatOutput {
    let threat = input.currentThreat + input.dailyThreatDelta;
    if (threat < 0) threat = 0;
    threat += input.policyThreatEffectTotal / 30;

    let complianceDelta: number | undefined;
    let breachEvent: ThreatBreachEvent | undefined;
    let playAlertSfx = false;

    if (threat >= 100) {
      if (input.hasDiode) {
        threat = 80;
        complianceDelta = -10;
        breachEvent = 'diode_mitigated';
      } else {
        threat = 50;
        complianceDelta = -30;
        breachEvent = 'data_breach';
        playAlertSfx = true;
      }
    }

    const threatHistory = [...input.threatHistory.slice(1), threat];

    this.deps.logger?.log('debug', 'threat.evaluated', {
      threat,
      breachEvent,
    });

    return {
      threat,
      threatHistory,
      complianceDelta,
      breachEvent,
      playAlertSfx,
    };
  }
}